import { type HttpResponsePayload, createHttpEndpoint } from '../../utils'

export interface PostAnswersPayload {
  sourcingListingId: string
}

export type PostAnswersResponse = HttpResponsePayload<PostAnswersPayload>

/**
 * POST Buyback Asnwers payload
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/BuyBackAnswers}
 */

export const postBuybackAnswers = createHttpEndpoint<PostAnswersResponse>({
  method: 'POST',
  operationId: 'postBuybackAnswers',
  path: '/bm/sourcing/form/answers',
})
